/* Oak & Velvet · product and cart pages. Progressive enhancement only: the
   product form, the gallery links and the cart steppers all work without it. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const routes = (window.ov && window.ov.routes) || {};
  const desktop = window.matchMedia('(min-width: 990px)');

  /* ── Quantity steppers on the product form ── */
  document.addEventListener('click', (e) => {
    const step = e.target.closest('[data-qty-step]');
    if (!step) return;
    const input = step.closest('[data-qty]').querySelector('input');
    const min = Number(input.min || 1);
    const max = input.max ? Number(input.max) : Infinity;
    const next = Math.min(max, Math.max(min, (Number(input.value) || min) + Number(step.dataset.qtyStep)));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ── Variant picker ── */
  $$('[data-product]').forEach((root) => {
    const picker = $('[data-variant-picker]', root);
    const data = $('[data-variants]', root);
    if (!picker || !data) return;
    const variants = JSON.parse(data.textContent);
    const idInput = $('[data-variant-id]', root);
    const add = $('[data-add]', root);
    const qty = $('[data-qty] input', root);
    picker.hidden = false;
    idInput.disabled = false;

    const selected = () => $$('fieldset', picker).map((f) => (f.querySelector('input:checked') || {}).value);
    const update = () => {
      const opts = selected();
      const v = variants.find((x) => x.options.every((o, i) => o === opts[i]));
      opts.forEach((val, i) => { const l = $(`[data-option-label="${i}"]`, picker); if (l) l.textContent = val || ''; });
      if (!v) {
        add.disabled = true; add.textContent = 'Niet leverbaar';
        return;
      }
      idInput.value = v.id;
      $('[data-price]', root).innerHTML = v.price;
      $('[data-stock]', root).innerHTML = v.stock;
      add.disabled = !v.available;
      add.textContent = v.available ? 'In winkelwagen' : 'Uitverkocht';
      $$('[data-qty] button, [data-qty] input', root).forEach((el) => { el.disabled = !v.available; });
      if (v.max) qty.max = v.max; else qty.removeAttribute('max');
      if (qty.max && Number(qty.value) > Number(qty.max)) qty.value = qty.max;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
    };
    /* Mark values that have no available variant with the other choices kept. */
    const markAvailability = () => {
      const opts = selected();
      $$('fieldset', picker).forEach((f, i) => {
        $$('input', f).forEach((input) => {
          const test = opts.slice(); test[i] = input.value;
          const ok = variants.some((x) => x.available && x.options.every((o, j) => o === test[j]));
          input.closest('.seg__opt').classList.toggle('is-unavailable', !ok);
        });
      });
    };
    picker.addEventListener('change', () => { update(); markAvailability(); });
    markAvailability();
  });

  /* ── Gallery: collapse long sets on desktop, count on mobile, viewer ── */
  $$('[data-gallery]').forEach((list) => {
    const items = $$('.pg__item', list);
    const more = $('[data-gallery-more]');
    if (more && items.length > 7) {
      list.classList.add('is-collapsed');
      more.hidden = false;
      more.addEventListener('click', () => {
        const open = list.classList.toggle('is-collapsed') === false;
        more.setAttribute('aria-expanded', String(open));
        more.textContent = open ? "Minder foto's" : `Alle ${items.length} foto's`;
        if (open) { const a = items[7] && items[7].querySelector('a'); if (a) a.focus(); }
      });
    }

    const count = $('[data-gallery-count]');
    if (count && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => { if (en.isIntersecting && en.intersectionRatio > 0.6) count.textContent = `${Number(en.target.dataset.index) + 1} / ${items.length}`; });
      }, { root: list, threshold: [0.6] });
      items.forEach((it) => io.observe(it));
    }

    const dialog = $('[data-zoom-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const links = $$('[data-zoom]', list);
    const img = $('[data-zoom-img]', dialog);
    const label = $('[data-zoom-count]', dialog);
    let index = 0;
    let opener = null;
    const show = (i) => {
      index = (i + links.length) % links.length;
      const a = links[index];
      const thumb = a.querySelector('img');
      img.src = a.href;
      img.alt = thumb ? thumb.alt : '';
      label.textContent = `${index + 1} / ${links.length}`;
    };
    links.forEach((a, i) => a.addEventListener('click', (e) => {
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      opener = a;
      show(i);
      dialog.showModal();
      $('[data-zoom-close]', dialog).focus();
    }));
    dialog.addEventListener('click', (e) => {
      const step = e.target.closest('[data-zoom-step]');
      if (step) show(index + Number(step.dataset.zoomStep));
      if (e.target.closest('[data-zoom-close]')) dialog.close();
    });
    dialog.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); show(index + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(index - 1); }
    });
    dialog.addEventListener('close', () => { if (opener) opener.focus(); });
  });

  /* ── Sticky info column: stick by its bottom edge when taller than the viewport ── */
  $$('[data-sticky]').forEach((el) => {
    const header = 97;
    const set = () => {
      if (!desktop.matches) { el.style.top = ''; return; }
      const room = window.innerHeight - el.offsetHeight - 32;
      el.style.top = `${Math.min(header, room)}px`;
    };
    set();
    if ('ResizeObserver' in window) new ResizeObserver(set).observe(el);
    window.addEventListener('resize', set);
  });

  /* ── Recommendations (Section Rendering API) ── */
  $$('[data-recommendations]').forEach(async (section) => {
    try {
      const res = await fetch(section.dataset.url);
      if (!res.ok) return;
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const fresh = doc.querySelector('[data-recommendations-list]');
      if (!fresh) return;
      const shown = new Set($$('[data-related-collection] [data-product-id]').map((li) => li.dataset.productId));
      const limit = Number(section.dataset.limit) || 4;
      const keep = $$('[data-product-id]', fresh).filter((li) => !shown.has(li.dataset.productId)).slice(0, limit);
      if (keep.length < 2) return;
      const list = $('[data-recommendations-list]', section);
      list.replaceChildren(...keep.map((li) => document.importNode(li, true)));
      section.hidden = false;
    } catch (err) { /* recommendations are optional */ }
  });

  /* ── Cart page: in-place updates ── */
  const cartPage = () => $('[data-cart-page]');
  const enhanceCart = () => {
    const page = cartPage();
    if (page) page.classList.add('pc--js');
  };
  enhanceCart();

  function render(html, message, focusKey) {
    const page = cartPage();
    if (html && page) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const next = doc.querySelector('[data-cart-page]');
      if (next) page.replaceWith(next);
    }
    enhanceCart();
    const now = cartPage();
    if (!now) return;
    const msg = $('[data-cart-page-status]', now);
    if (msg) msg.textContent = message;
    const target = (focusKey && $(`[data-focus="${focusKey}"]`, now)) || $('[data-cart-title]', now);
    if (target) target.focus();
    if (window.ovCart && window.ovCart.refresh) window.ovCart.refresh();
  }

  let busy = false;
  async function changeLine(line, quantity, focusKey) {
    const page = cartPage();
    if (!page || busy) return;
    busy = true;
    page.setAttribute('aria-busy', 'true');
    const sectionId = page.dataset.section;
    const status = $('[data-cart-page-status]', page);
    try {
      const res = await fetch(`${routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(quantity) || 0), sections: [sectionId], sections_url: window.location.pathname }),
      });
      const json = await res.json();
      if (!res.ok) throw new Error(json.description || json.message || 'Bijwerken lukte niet');
      render(json.sections && json.sections[sectionId], Number(quantity) === 0 ? 'Verwijderd uit je winkelwagen.' : 'Je winkelwagen is bijgewerkt.', focusKey);
    } catch (err) {
      /* Re-render from the real cart so the page never shows a quantity the cart does not hold. */
      try {
        const res = await fetch(`${routes.cart}?sections=${encodeURIComponent(sectionId)}`);
        const json = await res.json();
        render(json[sectionId], err.message, focusKey);
      } catch (e) { if (status) status.textContent = err.message; }
    } finally {
      busy = false;
      const now = cartPage();
      if (now) now.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-cart-page] [data-line-change]');
    if (!a) return;
    e.preventDefault();
    changeLine(a.dataset.line, a.dataset.qty, a.dataset.focus);
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cart-page] [data-line-input]');
    if (input) {
      if (input.max && Number(input.value) > Number(input.max)) input.value = input.max;
      changeLine(input.dataset.line, input.value, input.dataset.focus);
      return;
    }
    const note = e.target.closest('[data-cart-page] [data-cart-note]');
    if (note) {
      fetch(`${routes.cart}/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ note: note.value }) });
    }
  });
  /* Enter in a quantity field updates that line instead of submitting the whole form. */
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter') return;
    const input = e.target.closest('[data-cart-page] [data-line-input]');
    if (!input) return;
    e.preventDefault();
    changeLine(input.dataset.line, input.value, input.dataset.focus);
  });
})();
